import React, { useState, useEffect } from   'react';
import {NavLink, useNavigate, useParams } from 'react-router-dom';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import apiService from '../../Auth/apiService';
import MenuPersonasSSV from './MenuPersonasSSV';
import { useAuth } from '../../Auth/AuthContext';
import { Card, CardHeader, CardBody, CardFooter, Button, Form, Row, Col, FormGroup } from 'react-bootstrap';
import { FaSave, FaArrowAltCircleRight } from 'react-icons/fa';
import { useForm } from 'react-hook-form';
import CargandoSpinner from '../Utils/CargandoSpinner';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
function CalcularEdad(date){
            return moment().diff(date, 'years');
        }
export default function SSVSalud() {
    const { token } = useAuth();
    const { idEncuesta, idPersona } = useParams();
    const [Cargando, setCargando] = useState(false);
    const [edad, setEdad] = useState('');
    const navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({});
    const defaultValues = {
        id: 0,
        idenc_idficha: '',
    };
    const { watch, handleSubmit, register, setValue, getValues, reset, trigger, control, formState: { errors }} = useForm({ 
            defaultValues: defaultValues
        }
    );
    const fetchData = async (idPersona, idEncuesta) => {
        let url = `/encuestassv/salud/crearformulariosalud`;
        let obj = { idPersona: idPersona, idEncuesta: idEncuesta };
        await apiService.post(url, obj, token)
        .then(response => {
            const result = response.data;

            resetForm(result.datosSalud);
            console.log('Datos de salud obtenidos:', result);
        })
        .catch(error => {
            if (error.response.data.message) {
                Mensaje('Error', error.response.data.message);
            } else {
                Mensaje('Error', 'No se pudieron obtener los datos básicos de la persona.');
            }
        })
        .finally(() => {
            setCargando(false);
        });
    };
  
    useEffect(() => {
        fetchData(idPersona, idEncuesta);
    }, [idPersona, idEncuesta]);
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    async function GuardarDatosSalud() {
        const valid = await trigger(); 
        if (!valid) {
            setSwalProps({
                show: true,
                title: 'Validar formulario',
                text: 'Por favor complete el formulario correctamente antes de guardar.',
                icon: 'warning',
            });
            return;
        }
        const datosFormulario = getValues();
        let url = `/encuestassv/salud/guardardatossalud`;
        
        setCargando(true);
        await apiService.post(url, datosFormulario, token)
        .then(response => {
            const result = response.data;
            if (response.status === 200) {
                Mensaje('Guardar', result.message + ' Id: ' + result.id);
            } else {
                Mensaje('Error', 'No se pudieron guardar los datos de salud de la persona.');
            }
        })
        .catch(error => {
            if (error.response.data.message) {
                Mensaje('Error', error.response.data.message);
            } else {
                Mensaje('Error', 'No se pudieron guardar los datos de salud de la persona.');
            }
        })
        .finally(() => {
            setCargando(false);
        });
    }
    
    const resetForm = (data) => {
        if (data) {
            reset((prevValues) => ({
                ...prevValues,
                id: data.id || '',
                cons_ficha_id: data.cons_ficha_id || '',
                nombre: data.nombre || '',
                edad_calculada: data.edad_calculada || '',
                salud_esta_afiliado: data.salud_esta_afiliado || '',
                salud_tipo_afiliacion: data.salud_tipo_afiliacion || '',
                salud_nombre_entidad: data.salud_nombre_entidad || '',
                salud_razon_no_afiliado: data.salud_razon_no_afiliado || '',
                salud_ultimos_12_meses_atencion_negada: data.salud_ultimos_12_meses_atencion_negada || '',
                salud_cual_barrera_atencion: data.salud_cual_barrera_atencion || '',
                salud_otra_cual: data.salud_otra_cual || '',
                salud_nnmenor_5_esta_cumpliendo_vacunacion: data.salud_nnmenor_5_esta_cumpliendo_vacunacion || '',
                salud_menor_de_5a10_vacunacion_completa: data.salud_menor_de_5a10_vacunacion_completa || '',
                salud_menores_de_5_asisten_crecimiento_desarrollo: data.salud_menores_de_5_asisten_crecimiento_desarrollo || '',
                salud_integrante_con_acompanamiento_psicosocial: data.salud_integrante_con_acompanamiento_psicosocial || '',
                salud_ha_recibido_acompanamiento_psicosocial: data.salud_ha_recibido_acompanamiento_psicosocial || '',
                salud_actual_requiere_atencion_psicosocial: data.salud_actual_requiere_atencion_psicosocial || '',
                salud_observaciones: data.salud_observaciones || '',
            }))
            setEdad(CalcularEdad(data.datos_basicos_fecha_nacimiento));
        }
    }
    
    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">SSV Personas salud</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                        <li className="breadcrumb-item"><NavLink to={`/encuestassv/id/${idEncuesta}`} > Ficha</NavLink></li>
                        <li className="breadcrumb-item active"> Salud</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </div>
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div className="container-fluid">
                    <MenuPersonasSSV idEncuesta={idEncuesta} idPersona={idPersona}></MenuPersonasSSV>
                    <hr />
                    <Form onSubmit={handleSubmit(GuardarDatosSalud)}>
                        <Card>
                            <CardHeader>
                                <h2>Para cada integrante de la familia</h2>
                                <b>Aplica para todas las personas del hogar. Para menores de 15 años, contesta el informante idoneo.</b>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col md={2}>
                                        <FormGroup>
                                        <Form.Label htmlFor="id">id</Form.Label>
                                        <Form.Control 
                                            readOnly 
                                            id="id"
                                            placeholder="id" 
                                            type="text"
                                            {...register("id")}/>
                                        </FormGroup>  
                                    </Col>
                                    <Col md={2}>
                                        <FormGroup>
                                        <Form.Label htmlFor="cons_ficha_id">Nro Ficha</Form.Label>
                                        <Form.Control 
                                            readOnly 
                                            id="cons_ficha_id"
                                            placeholder="cons_ficha_id" 
                                            type="text"
                                            {...register("cons_ficha_id")}/>
                                        </FormGroup>  
                                    </Col>
                                    <Col md={4}>
                                    <FormGroup>
                                        <Form.Label htmlFor="nombre">Nombre de la persona</Form.Label  >
                                        <Form.Control 
                                            readOnly 
                                            id="nombre" 
                                            placeholder="Nombre" 
                                            type="text"
                                            {...register("nombre")}/>
                                    </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label htmlFor="edad_calculada">Edad</Form.Label>
                                        <Form.Control readOnly id="edad_calculada" placeholder="Edad" type="text" value={edad}/>
                                    </FormGroup>
                                    </Col>
                                </Row>
                                
                                <Row>
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label>1. Se encuentra afiliado al sistema de seguridad social en salud</Form.Label>
                                        <Form.Control as="select" id="salud_esta_afiliado" style={{width: "100%"}} aria-hidden="true" {...register("salud_esta_afiliado")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No (Pase a la pregunta 4)</option>
                                        <option value="3">3. NS/NR (Pase a la pregunta 5)</option>
                                        </Form.Control>
                                        {errors.salud_esta_afiliado && <span className="text-danger">Este campo es requerido</span>}
                                        <div className="dersuperado" >
                                        <button id="saludseguimiento" type="button" className="btn btn-primary btn-xs" data-toggle="modal" data-target="#modal-seguimientoderecho">
                                            Superación del derecho
                                        </button>
                                        </div>
                                    </FormGroup>
                                    </Col>
                                    
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label>2. Tipo de afiliación</Form.Label>
                                        <Form.Control as="select" id="salud_tipo_afiliacion" style={{width: "100%"}} aria-hidden="true" {...register("salud_tipo_afiliacion")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Subsidiado</option>
                                        <option value="2">2. Contributivo</option>
                                        <option value="3">3. Especial (Fuerza pública, clero, magisterio)</option>
                                        </Form.Control>
                                        {errors.salud_tipo_afiliacion && <span className="text-danger">Este campo es requerido</span>}
                                    </FormGroup>
                                    </Col>
                                    
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label htmlFor="salud_nombre_entidad">3. Nombre de la entidad dónde se halla afiliado</Form.Label>
                                        <Form.Control id="salud_nombre_entidad" placeholder="Nombre de la entidad" type="text" {...register("salud_nombre_entidad")}/>
                                        {errors.salud_nombre_entidad && <span className="text-danger">Este campo es requerido</span>}
                                        <p>Despues de diligenciar este dato PASE A LA PREGUNTA 5</p>
                                        </FormGroup>  
                                    </Col> 
                                    
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label htmlFor="salud_razon_no_afiliado">4. Si no está afiliado ¿Cuál es la razón por la cual no se encuentra afiliado a algún régimen de salud?</Form.Label>
                                        <Form.Control as="select" id="salud_razon_no_afiliado" style={{width: "100%"}} aria-hidden="true" {...register("salud_razon_no_afiliado")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. No sabe como afiliarse</option>
                                        <option value="2">2. Dificultad en el trámite</option>
                                        <option value="3">3. Negación del trámite</option>
                                        <option value="4">4. No le interesa</option>
                                        </Form.Control>
                                        {errors.salud_razon_no_afiliado && <span className="text-danger">Este campo es requerido</span>}

                                    </FormGroup>
                                    </Col>
                                    
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label htmlFor="salud_ultimos_12_meses_atencion_negada">5. En los últimos doce meses, ¿Le han negado la atención en salud?</Form.Label>
                                        <Form.Control as="select" id="salud_ultimos_12_meses_atencion_negada" style={{width: "100%"}} aria-hidden="true" {...register("salud_ultimos_12_meses_atencion_negada")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No PASE A LA PREGUNTA 7</option>
                                        </Form.Control>
                                        {errors.salud_ultimos_12_meses_atencion_negada && <span className="text-danger">Este campo es requerido</span>}
                                    </FormGroup>
                                    </Col>
                                    
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label htmlFor="salud_cual_barrera_atencion">6. Si la respuesta anterior es si..¿ Cual ha sido el tipo de barrera?</Form.Label>
                                        <Form.Control as="select" id="salud_cual_barrera_atencion" style={{width: "100%"}} aria-hidden="true" {...register("salud_cual_barrera_atencion")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Exigencia como prerrequisito para la atención en salud, el documento de remision fisica del Equipo de Atención y Reparación a Víctimas.</option>
                                        <option value="2">2. Cobro de cuota moderadora y/o copagos en régimen subsidiado</option>
                                        <option value="3">3. Negación en la prestación del servicio.</option>
                                        <option value="4">4. Otra, Cuál?</option>
                                        </Form.Control>
                                        {errors.salud_cual_barrera_atencion && <span className="text-danger">Este campo es requerido</span>}
                                        <Form.Control id="salud_otra_cual" placeholder="Cual" type="text" {...register("salud_otra_cual")} />
                                        {errors.salud_otra_cual && <span className="text-danger">Este campo es requerido</span>}

                                    </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <div className="col-md-12" >
                                    <hr/>
                                    <h4>Las preguntas 7 a 9 aplica solo para niños y niñas entre 0 y 10 años</h4>
                                    </div>
                                </Row>
                                <Row>
                                    <Col md={4}>
                                    <FormGroup>
                                        <Form.Label htmlFor="salud_nnmenor_5_esta_cumpliendo_vacunacion">7. ¿Los niños y niñas menores de 5 años están cumpliendo su esquema de vacunación?</Form.Label>
                                        <Form.Control as="select" id="salud_nnmenor_5_esta_cumpliendo_vacunacion" style={{width: "100%"}} aria-hidden="true" {...register("salud_nnmenor_5_esta_cumpliendo_vacunacion")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        </Form.Control>
                                        {errors.salud_nnmenor_5_esta_cumpliendo_vacunacion && <span className="text-danger">Este campo es requerido</span>}
                                    </FormGroup>
                                    </Col>
                                    
                                    <Col md={4}>
                                    <FormGroup>
                                        <Form.Label htmlFor="salud_menor_de_5a10_vacunacion_completa">8. ¿Los niños y niñas entre 5 y 10 años de edad tiene el esquema de vacunación completo?</Form.Label>
                                        <Form.Control as="select" id="salud_menor_de_5a10_vacunacion_completa" style={{width: "100%"}} aria-hidden="true" {...register("salud_menor_de_5a10_vacunacion_completa")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        </Form.Control>
                                        {errors.salud_menor_de_5a10_vacunacion_completa && <span className="text-danger">Este campo es requerido</span>}
                                    </FormGroup>
                                    </Col>
                                    
                                    <Col md={4}>
                                    <FormGroup>
                                        <Form.Label htmlFor="salud_menores_de_5_asisten_crecimiento_desarrollo">9. ¿los niños y niñas menores de 5 años asisten a controles de crecimiento y desarrollo?</Form.Label>
                                        <Form.Control as="select" id="salud_menores_de_5_asisten_crecimiento_desarrollo" style={{width: "100%"}} aria-hidden="true" {...register("salud_menores_de_5_asisten_crecimiento_desarrollo")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        </Form.Control>
                                        {errors.salud_menores_de_5_asisten_crecimiento_desarrollo && <span className="text-danger">Este campo es requerido</span>}

                                    </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12} align="center">
                                    <hr/>
                                    <h4>Aplica solo para personas víctimas del conflicto armado.</h4>
                                    </Col>
                                </Row>
                                <Row>  
                                    <Col md={4}>
                                    <FormGroup>
                                        <Form.Label htmlFor="salud_integrante_con_acompanamiento_psicosocial">10. ¿Algún integrante del grupo familiar víctima del conflicto ha solicitado atención o rehabilitación psicosocial debido a “molestias” emocionales causadas por el conflicto armado?</Form.Label>
                                        <Form.Control as="select" id="salud_integrante_con_acompanamiento_psicosocial" style={{width: "100%"}} aria-hidden="true" {...register("salud_integrante_con_acompanamiento_psicosocial")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Sí</option>
                                        <option value="2">2. No (PASE A LA PREGUNTA 12)</option>
                                        <option value="98">98. NS/NR (PASE A LA PREGUNTA 12)</option>
                                        </Form.Control>
                                        {errors.salud_integrante_con_acompanamiento_psicosocial && <span className="text-danger">Este campo es requerido</span>}
                                        <p>Nota: Tratar a lo maximo de lograr como respuesta un "Si" o un "No"</p>
                                    </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                    <FormGroup>
                                        <Form.Label htmlFor="salud_ha_recibido_acompanamiento_psicosocial">11. Si la respuesta anterior es "Si", ¿Ha recibido la atención o la rehabilitación psicosocial solicitada?</Form.Label>
                                        <Form.Control as="select" id="salud_ha_recibido_acompanamiento_psicosocial" style={{width: "100%"}} aria-hidden="true" {...register("salud_ha_recibido_acompanamiento_psicosocial")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Sí</option>
                                        <option value="2">2. Si programaron, pero no se asistió</option>
                                        <option value="3">3. No</option>
                                        </Form.Control>
                                        {errors.salud_ha_recibido_acompanamiento_psicosocial && <span className="text-danger">Este campo es requerido</span>}

                                    </FormGroup>
                                    </Col>
                                    
                                    <Col md={4}>
                                    <FormGroup>
                                        <Form.Label htmlFor="salud_actual_requiere_atencion_psicosocial">12. ¿Considera que en la actualidad algún integrante de la familia víctima del conflicto, requiere atención o rehabilitación psicosocial debido "molestias" emocionales causadas por el conflicto armado?</Form.Label>
                                        <Form.Control as="select" id="salud_actual_requiere_atencion_psicosocial" style={{width: "100%"}} aria-hidden="true" {...register("salud_actual_requiere_atencion_psicosocial")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Sí</option>
                                        <option value="2">2. No</option>
                                        <option value="98">98. NS/NR</option>
                                        </Form.Control>
                                        {errors.salud_actual_requiere_atencion_psicosocial && <span className="text-danger">Este campo es requerido</span>}

                                        <p>Nota: Tratar a lo máximo de lograr como respuesta un "Si" o un "No"</p>
                                    </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                    <FormGroup>
                                        <Form.Label htmlFor="salud_observaciones">Observaciones</Form.Label>
                                        <textarea id="salud_observaciones" className="form-control" rows="3" placeholder="Observaciones" {...register("salud_observaciones")}></textarea>
                                        {errors.salud_observaciones && <span className="text-danger">Este campo es requerido</span>}
                                    </FormGroup>  
                                    </Col>  
                                </Row>
                            </CardBody>
                            <CardFooter>
                                <div className="d-flex flex-wrap align-items-center" style={{ gap: '12px' }}>
                                    <Button type='submit' id="btnPersonaBasicosGuardar" className="btn btn-primary">
                                        <FaSave />
                                        Guardar
                                    </Button>
                                    <Button 
                                        id="btnPersonaBasicosCancel" 
                                        className="btn btn-secondary"
                                        onClick={() => {
                                            globalThis.location.href = `/encuestassv/id/${idEncuesta}`;
                                        }
                                        }>
                                        <FaArrowAltCircleRight />
                                        Volver
                                    </Button>
                                </div>
                            </CardFooter>
                        </Card>
                    </Form>
                </div>
                <SweetAlert2 {...swalProps} 
                    didClose={() => {
                        setSwalProps({})
                    }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>
            
        </div>
      
  )
  }